<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Yonetim"
    }
</script>

<style scoped>

</style>